module.exports = __webpack_public_path__ + "static/media/ctm.b2184296.jpeg";